import type { ReactNode } from "react";
import { Fragment, memo } from "react";
import Content, { SizeContentType } from "../../pages/procedure/components/Content";
import "./table.scss";

export type TableColumn<TRow> = {
  title: ReactNode;
  hidden?: boolean;
  size?: SizeContentType;
  renderCell: (row: TRow, rowNumber: number) => ReactNode;
};

export type TableProps<TData> = {
  data: TData[];
  columns: TableColumn<TData>[];
  getRowKey?: (row: TData) => string | number;
};

function Table<TData>(props: TableProps<TData>) {
  const { data, columns, getRowKey } = props;

  return (
    <div className="detailTable">
      <table className="table table-striped mb-4">
        <thead>
          {columns.map((col, index) => {
            const { title } = col;

            return (
              <Fragment key={index}>
                {!col.hidden && (
                  <th>
                    <p className="text-nowrap">{title}</p>
                  </th>
                )}
              </Fragment>
            );
          })}
        </thead>
        <tbody>
          {data.map((row, index) => {
            const key = getRowKey?.(row) ?? index;

            return (
              <tr key={key}>
                {columns.map((col, colIndex) => {
                  return (
                    <Fragment key={colIndex}>
                      {!col.hidden && (
                        <td>
                          <Content size={col.size}>{col.renderCell(row, index + 1)}</Content>
                        </td>
                      )}
                    </Fragment>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default memo(Table);
